import axios from '../../util/axios-portals';

import * as actionTypes from './actionTypes';
import { setAuthInformation } from './auth';

export const changePasswordStart = () => {
    return {
        type: actionTypes.CHANGE_PASSWORD_START
    };
}

export const changePasswordSuccess = () => {
    return {
        type: actionTypes.CHANGE_PASSWORD_SUCCESS
    };
}

export const changePasswordFail = (error) => {
    return {
        type: actionTypes.CHANGE_PASSWORD_FAIL, 
        error
    }
}

export const changePassword = (old_password, new_password, new_password_confirm, token) => {
    return (dispatch) => {
        dispatch(changePasswordStart());

        const formData = {
            old_password, 
            new_password, 
            new_password_confirm
        };

        const config = {
            headers: {
                Authorization: `Bearer ${token}`, 
                Accept: 'application/json'
            }
        };

        axios.post('/user/change_password', formData, config)
            .then(response => {
                const { token, expiresIn, role } = response.data;
                dispatch(setAuthInformation(token, expiresIn, role));
                dispatch(changePasswordSuccess())
            })
            .catch(err => dispatch(changePasswordFail(err)));
    };
}

export const loadSecurityQuestionsStart = () => {
    return {
        type: actionTypes.SECURITY_QUESTIONS_LOAD_START
    }
};

export const loadSecurityQuestionsSuccess = (questions) => {
    return {
        type: actionTypes.SECURITY_QUESTIONS_LOAD_SUCCESS, 
        questions 
    }
}

export const loadSecurityQuestionsFail = (error) => {
    return {
        type: actionTypes.SECURITY_QUESTIONS_LOAD_FAIL, 
        error
    };
}

export const loadSecurityQuestions = (token) => {
    return dispatch => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`, 
                Accept: 'application/json'
            }
        };

        axios.get('/user/security_questions', config)
            .then(response => dispatch(loadSecurityQuestionsSuccess(response.data.answers)))
            .catch(err => dispatch(loadSecurityQuestionsFail(err)));
    }
}

export const setSecurityQuestionAnswersStart = () => {
    return {
        type: actionTypes.SECURITY_QUESTIONS_CHANGE_START
    };
}

export const setSecurityQuestionAnswersSuccess = () => {
    return {
        type: actionTypes.SECURITY_QUESTIONS_CHANGE_SUCCESS
    };
}

export const setSecurityQuestionAnswersFail = (error) => {
    return {
        type: actionTypes.SECURITY_QUESTIONS_CHANGE_FAIL, 
        error
    };
}

export const setSecurityQuestionAnswers = (answers, token) => {
    const formData = {
        SecurityQuestionAnswers: answers
    };

    const config = {
        headers: {
            Authorization: `Bearer ${token}`, 
            Accept: 'application/json'
        }
    };

    return dispatch => {
        dispatch(setSecurityQuestionAnswersStart());

        axios.post('/user/security_questions', formData, config)
            .then(() => dispatch(setSecurityQuestionAnswersSuccess()))
            .catch(err => dispatch(setSecurityQuestionAnswersFail(err)));
    };
}